'use client'

import { ProtectedRoute } from './protected-route';
import { LandingPageComponent } from './landing-page-content';

export function LandingPage() {
  return (
    <ProtectedRoute>
      <LandingPageComponent />
    </ProtectedRoute>
  );
}